import React from "react";
import Container from "@mui/material/Container";

export default function ContainerBody(props) {
  const style = {
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "auto 0.7",
    // padding: "20px",
    // height: "90vh",
  };

  return <Container style={style}>{props.children}</Container>;
}
